import { getEndpoint, getHeaders } from '../../helpers/endpoint';

export const REQUEST_JOBS_STATES = 'REQUEST_JOBS_STATES';
export const SUCCESS_JOBS_STATES = 'SUCCESS_JOBS_STATES';
export const FAIL_JOBS_STATES = 'FAIL_JOBS_STATES';

export const getJobStates = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({ type: REQUEST_JOBS_STATES, payload, scope });

    return fetch(getEndpoint('jobs', { category: 'in_and_out' }), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          return dispatch({
            type: FAIL_JOBS_STATES,
            error: data.error,
            payload,
            scope
          });
        } else return dispatch(successJobStates(data, payload, scope));
      })
      .catch((error, type = FAIL_JOBS_STATES) => dispatch({ type, error, payload, scope }));
  };
};

function successJobStates(response, payload, scope) {
  return dispatch =>
    dispatch({
      type: SUCCESS_JOBS_STATES,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope
    });
}



// WEBPACK FOOTER //
// ./src/actions/entities/jobs.js